import { render, staticRenderFns } from "./OrganizationLogo.vue?vue&type=template&id=170dfafa&"
import script from "./OrganizationLogo.vue?vue&type=script&lang=js&"
export * from "./OrganizationLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VLazy,VResponsive})
